import React from "react";
import FileDialog from "./src/fileDialog";
import SearchForm from "./src/searchForm";
import FoundCounter from "./src/foundCounter";
import SearchParticipantLoader from "./src/searchParticipantLoader";
import RenderResults from "./src/renderResults";
import Section from "../../components/section/section";

const SearchParticipantContainer = (): React.JSX.Element => (
  <Section>
    <SearchForm />
    <FoundCounter />
    <SearchParticipantLoader />
    <RenderResults />
    <FileDialog />
  </Section>
);

export default SearchParticipantContainer;
